export default __webpack_public_path__ + "static/media/keyboard_arrow_down.041960f4.svg";